export const SET_INTENTS = 'SET_INTENTS';
export const CLEAR_INTENTS_CACHE = 'CLEAR_INTENTS_CACHE';
export const ADD_TO_INTENTS_CACHE = 'ADD_TO_INTENTS_CACHE';
export const UPDATE_INTENT_IN_CACHE = 'UPDATE_INTENT_IN_CACHE';
export const REMOVE_INTENT_FROM_CACHE = 'REMOVE_INTENT_FROM_CACHE';
